import { Component, OnInit, Inject } from '@angular/core';
import { LogLoginInfo } from '../model/loglogin.model';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';

import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';

@Component({
  selector: 'app-log-login',
  templateUrl: './log-login.component.html',
  styleUrls: ['./log-login.component.css']
})
export class LogLoginComponent implements OnInit {
//!check
  logLoginOnPromise: Promise<LogLoginInfo[]>
  logLoginList: LogLoginInfo[]

  //Pagination variable
  public currentPageNumber: number
  public LogTotal: any
  public totalPages: number
  public environment: number
  public indexNo: number

  element: HTMLElement;
  baseurl: string;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private activatedRoute: ActivatedRoute, private TokenService: TokenService, private GlobalService: GlobalService) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }


  async ngOnInit() {
    this.currentPageNumber = 1;
    this.environment = environment.PageSize;
    this.indexNo = 0;
    this.LoadLog();
  }
  ///////////////////////////////////////Events////////////////////////////////////////////

  LoadLog() {
    this.LoadLogList()
      .then(
        data => {
          this.logLoginList = data
        }
      )
      .then(() => {
        this.CountLogList()
      });
  }

  async LoadLogList(): Promise<LogLoginInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //double negation operator - ensuring value either true or false
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;

      var objjson = {};
      objjson['rowFetch'] = environment.PageSize;
      objjson['rowOFFSet'] = offset;
      let strjson = JSON.stringify(objjson);


      this.logLoginOnPromise = this.httpClient
        .post<LogLoginInfo[]>(this.baseurl + "LogLogin/GetLogLoginList",
          strjson, httpOptions)
        .toPromise();

      return this.logLoginOnPromise;
    }
  }

  async CountLogList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;


      let strjson = "{}";


      this.httpClient
        .post<LogLoginInfo[]>(this.baseurl + "LogLogin/GetCountLogLoginList",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.LogTotal = data
        })
        .then(() => {
          if(this.LogTotal == 0) this.currentPageNumber = 0;

          this.totalPages = Math.ceil(this.LogTotal / environment.PageSize)
        });
    }
  }




  //For Pagination
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;
  }

  OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadListPagination(traget);
      this.LoadLog();
    }

  }

}
